import * as React from "react";

import "./admin-mailing-assets-route.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {keyed}          from "@Common/react/keyed";
import {parseUrlQuery}  from "@Common/utils/parse-url-query";

import {SampleAddressSection} from "@Xpresso/routes/account/common/sample-address/sample-address";

import {AGENT_LEVEL}            from "../../../../../common/logic/user-level";
import {BulkMailPermit}         from "../../../../common/bulk-mail-permit/bulk-mail-permit";
import {IntelligentMailBarcode} from "../../../../common/intelligent-mail-barcode/intelligent-mail-barcode";
import {UserAssetsLayout}       from "../common/layout/user-assets-layout";

export const AccountAdminMailingAssetsRoute = () => cs(
    ({}, next) => UserAssetsLayout({activeTab: "admin-mailing-assets", next}),

    consumeContext("apis"),
    ["sections", ({apis}, next) => cs(
        ["agentId", ({}, next) => next(parseUrlQuery(window.location.search)?.agent)],
        ["imb", ({agentId}, next) => IntelligentMailBarcode({
            apis: {
                getMailerId: () => apis.next.imb.getMailerId({agentId}),
                saveMailerId: ({idMailer, idPrimary}) => apis.next.imb.saveMailerId({
                    idMailer,
                    idPrimary,
                    idEntity: agentId,
                }),
            },
            next,
        })],
        ["bulkMailPermit", ({agentId}, next) => BulkMailPermit({
            apis: {
                getIndica: () => {
                    // noinspection TypeScriptValidateJSTypes
                    return apis.next.bulkMailPermit.getIndica({agentId, userLevel: AGENT_LEVEL});
                },
                saveIndicia: ({id, indicia}) => {
                    // noinspection TypeScriptValidateJSTypes
                    return apis.next.bulkMailPermit.saveIndicia({
                        id,
                        indicia,
                        agentId,
                        userLevel: AGENT_LEVEL,
                    });
                },
            },
            next,
        })],
        ["sampleAddress", ({agentId}, next) => SampleAddressSection({
            next,
            idEntity: agentId,
        })],
        ({bulkMailPermit, imb, sampleAddress}) => next([bulkMailPermit, imb, sampleAddress]),
    )],

    ({sections}) => (
        <div className="admin-mailing-assets-route-5ur">
            {(sections.find((section) => section?.loading)) && (
                <div className="loading" xd-qa-type="label" xd-qa-name="loading">
                    <i className="fa fa-spinner fa-pulse"/>
                    Loading...
                </div>
            )}
            {sections.map((section, i) => section?.render && cs(
                keyed(i),
                ["content", (_, next) => section.render({next})],
                ({content}) => Section(content),
            ))}
        </div>
    )
);

const Section = ({header, content}) => (
    <div className="section">
        <div className="header">
            <div className="title" xd-qa-type="label" xd-qa-name={header.title}>
                {header.title}
            </div>

            <a {...{
                className: "edit",
                onClick: () => header.action.onClick(),
                "xd-qa-type": "link",
                "xd-qa-name": header.action.xdQaName,
            }}>
                {header.action.label}
            </a>
        </div>

        {header.subtitle && (
            <div className="subtitle" xd-qa-type="label" xd-qa-name={header.subtitle}>
                {header.subtitle}
            </div>
        )}

        {content}
    </div>
);
